"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOCIAL_MEDIA_TYPES = void 0;
var SOCIAL_MEDIA_TYPES = exports.SOCIAL_MEDIA_TYPES = {
  INSTAGRAM: 'instagram',
  YOUTUBE: 'youtube',
  SOUNDCLOUD: 'soundcloud',
  TWITTER: 'twitter',
  FACEBOOK: 'facebook',
  SPOTIFY: 'spotify'
};
Object.freeze(SOCIAL_MEDIA_TYPES);